import { render, staticRenderFns } from "./ImagesUploads.vue?vue&type=template&id=0c650847&scoped=true&"
import script from "./ImagesUploads.vue?vue&type=script&lang=tsx&"
export * from "./ImagesUploads.vue?vue&type=script&lang=tsx&"
import style0 from "./ImagesUploads.vue?vue&type=style&index=0&id=0c650847&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c650847",
  null
  
)

export default component.exports